import { ReactElement } from 'react';
import { useTranslate } from '@client/i18n/hooks';
import { ICON_NAME } from 'b2b-components/theme/components/Icon';
import { TagList } from 'b2b-components/theme/components/TagList';
import { Props } from './ResultsActiveFilters.types';
import './ResultsActiveFilters.scss';

export const ResultsActiveFilters = ({
  children,
  activeFilters,
  onRemoveAllFilters,
  onRemoveFilter,
}: Props): ReactElement | null => {
  const t = useTranslate();

  const hasActiveFilters = !!activeFilters.length;

  if (!hasActiveFilters && !children) {
    return null;
  }

  return (
    <div className='ResultsActiveFilters'>

      {children}

      {hasActiveFilters && <div className='Catalog-FormLabel'>{t('Active filters')}:</div>}

      <TagList
        onDismissAll={onRemoveAllFilters}
        text={{
          dismiss: t('Dismiss all filters'),
        }}
        tags={activeFilters.map((filter) => ({
          ...filter,
          onClick: () => onRemoveFilter(filter.section, filter.value),
          iconName: ICON_NAME.close,
        }))}
      />
    </div>
  );
};
